import { StorePlusOutlineIcon } from './StorePlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 585744D8-92B8-4874-81F5-70F659DA0DFE
 * name store-plus-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-plus-outline.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const ShopPlusOutlineIcon = StorePlusOutlineIcon;
export default ShopPlusOutlineIcon